import React from 'react';
import PropTypes from 'prop-types';
import ISA315ItAppScotAccordionControlsItem from './ISA315ItAppScotAccordionControlsItem';

function ISA315ItAppScotAccordionControlsList({controlIds, bodyId}) {
	if (Array.isArray(controlIds)) {
		return controlIds.map((controlId) => (
			<ISA315ItAppScotAccordionControlsItem controlId={controlId} bodyId={bodyId} />
		));
	}
	return null;
}

ISA315ItAppScotAccordionControlsList.propTypes = {
	controlIds: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default ISA315ItAppScotAccordionControlsList;
